import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { ChartJsComponent } from './chart-js.component';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [ChartJsComponent],
  exports: [ChartJsComponent]
})
export class ChartJsModule { }
